// extracted by mini-css-extract-plugin
export default {"icon":"zWFAcrPTJ2Bfiu24nixL"};